import React from "react";

import { LiabilityStatus } from "../../../types";
import { LiabilityHeroProps } from "./types";
import { LiabilitySummary } from "./LiabilitySummary";
import { NextPayment } from "./NextPayment";
import { HeroLayout } from "./styles";

export const LiabilityHero: React.FC<LiabilityHeroProps> = React.memo(
  ({
    liability,
    lastPaymentDate,
    dropdownActions,
    onLogPayment,
    onEditLiability,
  }) => {
    const isActive =
      liability.isActive && liability.status === LiabilityStatus.ACTIVE;

    return (
      <HeroLayout $single={!isActive} data-testid="liability-hero">
        <LiabilitySummary
          liability={liability}
          lastPaymentDate={lastPaymentDate}
          dropdownActions={dropdownActions}
        />

        {isActive && (
          <NextPayment
            liability={liability}
            onLogPayment={onLogPayment}
            onEditLiability={onEditLiability}
          />
        )}
      </HeroLayout>
    );
  },
);

LiabilityHero.displayName = "LiabilityHero";
